













































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TrackListItem, TrackSimilar } from '@/types';
import UTable, { TableField } from '@/ui-lib/table/Table.vue';
import { MusicPlayerTrack, player } from '@/components/music-player/Player.vue';
import UCheckbox from '@/ui-lib/checkbox/Checkbox.vue';
import UButton from '@/ui-lib/button/Button.vue';
import { TrackService, PlaylistService, TagService } from '@/api';
import { PlaylistsSelectModalParams } from '@/components/modals/PlaylistsSelectModal.vue';
import { TrackTagsSelectModalParams } from '@/components/modals/TrackTagsSelectModal.vue';
import { TrackShareCreateModalParams } from '@/components/modals/TrackShareCreateModal.vue';
import { SelectMultipleValue } from '@/ui-lib/select-field/SelectField.vue';
import { tag } from '@/store/modules/tag';

const plural = (count: number, one: string, few: string, many: string): string => {
  const mod100 = count % 100;

  if (mod100 >= 11 && mod100 <= 14) {
    return many;
  }

  switch (count % 10) {
    case 1:
      return one;
    case 2:
    case 3:
    case 4:
      return few;
    default:
      return many;
  }
};

@Component({
  components: {
    UTable,
    UCheckbox,
    UButton
  }
})
export default class TrackTableList extends Vue {
  @Prop({ required: true, type: Array })
  private list!: TrackListItem[];

  @Prop({ type: Boolean, default: true })
  private hasDownload!: boolean;

  @Prop({ type: Boolean, default: false })
  private hasSelectNext!: boolean;

  @Prop({ type: Boolean, default: false })
  private hasSelectDelete!: boolean;

  @Prop({ type: String, default: 'Удалить' })
  private selectDeleteLabel!: string;

  @Prop({ type: Boolean, default: false })
  private hasSelectPlaylists!: boolean;

  @Prop({ type: Boolean, default: false })
  private hasSelectCompilations!: boolean;

  @Prop({ type: Boolean, default: false })
  private hasSelectTags!: boolean;

  @Prop({ type: Array, default: () => [] })
  private selected!: number[];

  @Prop({ type: Boolean, default: false })
  private paginated!: boolean;

  @Prop({ type: String, default: 'Нет треков' })
  private emptyLabel!: string;

  @Prop({
    type: Array,
    default: (): TableField[] => [
      {
        name: 'select',
        label: '',
        width: '38px'
      },

      {
        name: 'play-pause',
        label: '',
        width: '56px'
      },

      {
        name: 'id',
        label: 'ID',
        width: '65px'
      },

      {
        name: 'title',
        label: 'Название'
      },

      {
        name: 'compilations',
        label: 'Подборки',
        width: '200px'
      },

      {
        name: 'playlists',
        label: 'Плейлисты',
        width: '200px'
      },

      {
        name: 'tags',
        label: 'Теги',
        width: '200px'
      },

      {
        name: 'likes',
        label: 'Лайки',
        width: '60px',
        align: 'right'
      },

      {
        name: 'dislikes',
        label: 'Дизлайки',
        width: '60px',
        align: 'right'
      },

      {
        name: 'listeners_per_month',
        label: 'Слуш/мес',
        width: '60px',
        align: 'right'
      },

      {
        name: 'skips_per_month',
        label: 'Скип/мес',
        width: '60px',
        align: 'right'
      },

      {
        name: 'controls',
        label: '',
        align: 'right',
        width: '50px'
      }
    ]
  })
  private fields!: TableField[];
  private getDownloadMP3URLIsLoading = false;

  private isLoading = false;

  private barWidth = 0;
  private barHeight = 0;
  private barPaddingLeft = 0;

  private similar(track: TrackListItem): TrackSimilar[] {
    return track.similar ?? [];
  }

  // `null` means the track has no audio vector yet, so nothing was compared —
  // distinct from an empty list, which means checked and clean. Right after an
  // upload, exactly when the editor looks for an accidental re-upload, a track
  // sits in this state until the hourly embedding job picks it up.
  private isSimilarUnchecked(track: TrackListItem): boolean {
    return track.similar === null;
  }

  private percent(similarTrack: TrackSimilar): string {
    if (similarTrack.similarity === null) {
      return '';
    }

    return `${(similarTrack.similarity * 100).toFixed(1)}%`;
  }

  private similarBadgeLabel(track: TrackListItem): string {
    const list = this.similar(track);

    if (list.some((s) => s.same_file)) {
      return list.length > 1 ? `Тот же файл +${list.length - 1}` : 'Тот же файл';
    }

    if (list.length > 1) {
      return `${list.length} ${plural(list.length, 'дубль', 'дубля', 'дублей')}`;
    }

    return `Дубль ${this.percent(list[0])}`.trim();
  }

  private compareRoute(track: TrackListItem, similarTrack: TrackSimilar) {
    return {
      name: 'trackList',
      query: { ids: `${track.id},${similarTrack.id}` }
    };
  }

  private compareAllRoute(track: TrackListItem) {
    const ids = [track.id, ...this.similar(track).map((s) => s.id)];

    return {
      name: 'trackList',
      query: { ids: ids.join(',') }
    };
  }

  private toggleSelectTrack(track: TrackListItem, val: boolean) {
    const i = this.selected.indexOf(track.id);

    if (val) {
      if (i === -1) {
        this.selected.push(track.id);
      }
    } else {
      if (i >= 0) {
        this.selected.splice(i, 1);
      }
    }
  }

  private coverStyle(track: TrackListItem) {
    if (track.albumImage === null) {
      return {};
    }

    return {
      backgroundImage: `url('${track.albumImage['50']}')`
    };
  }

  private togglePlay(track: TrackListItem) {
    const playerTrack: MusicPlayerTrack = {
      id: track.id,
      trackTitle: track.title,
      artistName: track.artist.name,
      src: track.url,
      image: track.albumImage?.['500']
    };

    player.togglePlay(playerTrack);
  }

  private changeCompilations(track: TrackListItem) {
    this.$modal.show('track-change-compilation', {
      track: track
    });
  }

  private changePlaylists(track: TrackListItem) {
    const ids = track.playlists.map((p) => p.id);

    const params: PlaylistsSelectModalParams = {
      selected: ids,
      onSelect: async () => {
        this.isLoading = true;

        try {
          const tr = await PlaylistService.trackSync(track.id, ids);

          track.playlists = tr.playlists;

          this.$notify({
            type: 'success',
            title: 'Трек обновлен'
          });

          this.$emit('playlists-changed', track);
        } catch (e) {
          this.$notify({
            type: 'error',
            title: 'Ошибка',
            text: e?.message || 'Неизвестная ошибка'
          });
        }

        this.isLoading = false;
      }
    };

    this.$modal.show('playlists-select', params);
  }

  private changeTags(track: TrackListItem) {
    const params: TrackTagsSelectModalParams = {
      selected: track.tags,
      trackIds: [track.id],
      onSelect: async (value: SelectMultipleValue) => {
        const tags: { name: string }[] = [];

        if (value) {
          if (Array.isArray(value)) {
            tags.push(...value.map((v) => ({ name: v.label })));
          } else {
            tags.push({ name: value.label });
          }
        }

        track.tags = await TagService.syncTrack(track.id, tags);
        await tag.context(this.$store).actions.loadList();

        this.$notify({
          type: 'success',
          title: 'Трек обновлен'
        });

        this.$emit('tags-changed', track);
      }
    };

    this.$modal.show('track-tags-select', params);
  }

  private isPlaying(track: TrackListItem): boolean {
    return player.isPlaying && player.playingTrack?.id === track.id;
  }

  private compilations(track: TrackListItem) {
    return track.compilations.filter(
      (v, ind) => ind === track.compilations.findIndex((t) => t.id === v.id)
    );
  }

  private rowClass(track: TrackListItem) {
    return { 'track-table-list_row__selected': this.selected.includes(track.id) };
  }

  private get pageSelectedCount(): number {
    return this.list.filter((track) => this.selected.includes(track.id)).length;
  }

  // Selection survives paging and search, so the bar may count tracks that aren't on screen.
  private get pageSelectedLabel(): string {
    if (!this.paginated || this.pageSelectedCount === this.selected.length) {
      return '';
    }

    return this.pageSelectedCount === 0
      ? ', все на других страницах'
      : `, на этой странице ${this.pageSelectedCount}`;
  }

  private get pageSelectableIDs(): number[] {
    return this.list.filter((track) => track.status === 1).map((track) => track.id);
  }

  private get isPageSelected(): boolean {
    return (
      this.pageSelectableIDs.length > 0 &&
      this.pageSelectableIDs.every((id) => this.selected.includes(id))
    );
  }

  private togglePageSelected(val: boolean) {
    // The checkbox also emits when its bound value changes from outside: unchecking one
    // row flips the page state to false, and acting on that echo would clear the page.
    if (val === this.isPageSelected) {
      return;
    }

    this.pageSelectableIDs.forEach((id) => {
      const i = this.selected.indexOf(id);

      if (val && i === -1) {
        this.selected.push(id);
      } else if (!val && i >= 0) {
        this.selected.splice(i, 1);
      }
    });
  }

  // The bar lives inside the sticky header cell of the select column so it sticks
  // with the header and adds no height, so it is stretched over the whole header row
  // by hand. Insets alone fall short: `bottom: 0` left it shorter than the row.
  private measureBar() {
    const table = this.$el.querySelector('.u-table_table') as HTMLElement | null;
    const th = this.$el.querySelector('.u-table_th') as HTMLElement | null;

    if (!table || !th) {
      return;
    }

    this.barWidth = table.offsetWidth;
    // +1 lays the bar's own bottom border over the header cell's border.
    this.barHeight = th.clientHeight + 1;

    const headerCheckbox = this.$refs.headerCheckbox as Vue | undefined;

    this.barPaddingLeft = headerCheckbox
      ? (headerCheckbox.$el as HTMLElement).getBoundingClientRect().left -
        th.getBoundingClientRect().left
      : parseFloat(getComputedStyle(th).paddingLeft) || 0;
  }

  // A new page or search result can change the table width without a window resize,
  // e.g. when a short list drops the page scrollbar.
  @Watch('selected.length')
  @Watch('list')
  private remeasureBar() {
    this.$nextTick(() => this.measureBar());
  }

  private mounted() {
    this.measureBar();
    window.addEventListener('resize', this.measureBar);
  }

  private beforeDestroy() {
    window.removeEventListener('resize', this.measureBar);
  }

  private unselectAll() {
    this.selected.splice(0);
  }

  private createShareLink() {
    const params: TrackShareCreateModalParams = {
      trackIDs: this.selected,
      // Left in place, the selection would quietly ride into the next link.
      onCreated: () => this.unselectAll()
    };

    this.$modal.show('track-share-create', params);
  }

  private async downloadSelected() {
    this.getDownloadMP3URLIsLoading = true;

    try {
      const { url } = await TrackService.getMP3DownloadURL(this.selected);

      const win = window.open(url, '_blank');

      if (win) {
        win.focus();
      }
    } catch (e) {
      alert(`Error: ${e.message}`);
    }

    this.getDownloadMP3URLIsLoading = false;
  }

  private selectNext() {
    this.$emit('select-next');
  }

  private selectDelete() {
    this.$emit('select-delete');
  }

  private selectPlaylists() {
    this.$emit('select-playlists');
  }

  private selectCompilations() {
    this.$emit('select-compilations');
  }

  private selectTags() {
    this.$emit('select-tags');
  }
}
